/**
 *
 * PureModeCourse
 *
 */
import { mapGetters, mapMutations /* , mapActions */ } from 'vuex';
//import $ from 'jquery';
//import Swal from 'sweetalert2';
import VueScrollTo from 'vue-scrollto';

import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Spinner from '@/components/Spinner.vue';

//import { IDENTITY_PAGE } from '@/constants/routes';

export default {
  name: 'PureModeCourse',

  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Spinner,
  },

  data() {
    return {
      // isHideFileDownLoadTip: true,
      promiseGetPureCourse: null,

      hideCurrentBtn: false,
    };
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    ...mapGetters({
      // Books: 'PureModeCourse/Books',
      isRequest: 'PureModeCourse/isRequest',
      Course: 'PureModeCourse/Course',
      lastRecord: 'PureModeCourse/lastRecord',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    //c_isNoAuth() {
    //  return Boolean(this.userInfo.authenticated === -1) && Boolean(this.userInfo.hasPay);
    //},
  },

  mounted() {
    window.scrollTo(0, 0);
    this._pureModeCourseMounted();
  },

  created() {
    this.promiseGetPureCourse = this.$store.dispatch('PureModeCourse/getPureCourse', this.CourseId);
  },

  methods: {
    ...mapMutations({
      mm_SET_GOTO_LAST_STUDY: 'SET_GOTO_LAST_STUDY',
    }),

    goBack() {
      this.$router.go(-1);
    },

    go2History() {
      VueScrollTo.scrollTo(`#book-${this.lastRecord.bookId}`, 500, {
        container: '.webapp-layout-main',
        duration: 500,
        easing: 'linear',
        offset: -220,
      });
      setTimeout(() => {
        this.mm_SET_GOTO_LAST_STUDY(true);
        this.$router.push(
          `/video-mode-course/${this.$route.params.courseId}/book/${this.lastRecord.bookId}`
        );
      }, 500);
    },

    async _pureModeCourseMounted() {
      await this.promiseGetPureCourse;
      setTimeout(() => {
        this.hideCurrentBtn = true;
      }, 15000);
      //if (!this.Course.freeMode && this.c_isNoAuth) {
      //  Swal.fire({
      //    icon: 'info',
      //    title: '您还没有认证',
      //    text: '亲爱的学员请先完成认证',
      //    confirmButtonColor: '#3085d6',
      //    confirmButtonText: '去认证',
      //    allowOutsideClick: false,
      //  }).then((result) => {
      //    if (result.value) {
      //      this.$router.push(IDENTITY_PAGE)
      //    }
      //  });
      //  return
      //}
    },
  },
};
